import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import DesignEditor from './components/DesignEditor';
import UserAgreement from './pages/about/UserAgreement';
import PrivacyNotice from './pages/about/PrivacyNotice';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import MyAccount from './pages/account/MyAccount';
import MyOrders from './pages/account/MyOrders';
import SavedDesigns from './pages/account/SavedDesigns';
import MyImages from './pages/account/MyImages';
import Likes from './pages/account/Likes';
import Collections from './pages/account/Collections';
import Income from './pages/account/Income';
import Referrals from './pages/account/Referrals';
import AboutUs from './pages/company/AboutUs';
import ContactUs from './pages/company/ContactUs';
import TrackOrder from './pages/company/TrackOrder';
import ReturnPolicy from './pages/company/ReturnPolicy';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PaymentPage from './pages/PaymentPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import ReferralProgram from './pages/company/ReferralProgram';
import UploadImages from './pages/uploadImages';
import MyImagesLite from './pages/MyImagesLite';
import BulkCreator from './pages/BulkCreator';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Routes>
        {/* 独立页面 - 不包含 Navbar 和 Footer */}
        <Route path="/uploadImages" element={<UploadImages />} />
        <Route path="/my-images-lite" element={<MyImagesLite />} />
        <Route path="/bulk-creator" element={<BulkCreator />} />
        
        {/* 主应用页面 - 包含 Navbar 和 Footer */}
        <Route path="/*" element={
          <div className="App flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductList />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/product/:id/:cacheKey" element={<ProductDetail />} />
                <Route path="/customize/:id" element={<DesignEditor />} />
                <Route path="/user-agreement" element={<UserAgreement />} />
                <Route path="/privacy-notice" element={<PrivacyNotice />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/order-success" element={<OrderSuccessPage />} />
                <Route path="/referral-program" element={<ReferralProgram />} />
                <Route path="/account" element={<MyAccount />} />
                <Route path="/orders" element={<MyOrders />} />
                <Route path="/saved-designs" element={<SavedDesigns />} />
                <Route path="/my-images" element={<MyImages />} />
                <Route path="/likes" element={<Likes />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/income" element={<Income />} />
                <Route path="/referrals" element={<Referrals />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/track-order" element={<TrackOrder />} />
                <Route path="/return-policy" element={<ReturnPolicy />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
